<template>
    <div class="payable-box">
        <HeaderNav
            header-title="应付情况"
            left-icon-name="2"
            right-icon-name="2"
            @change-org="handleChangeOrg"
        ></HeaderNav>
        <monthSelectTitle :tit="title" @change-month="changeMonth"></monthSelectTitle>
        <!-- 弹出日历控件 -->
        <van-popup
            v-model="showCalendar"
            position="bottom"
            :style="{ height: '50%' }"
        >
            <van-datetime-picker
                v-model="currentDate"
                type="year-month"
                :formatter="formatter"
                :max-date="maxDate"
                @confirm="confirmMonth"
                @cancel="cancelMonth"
            ></van-datetime-picker>
        </van-popup>
        <div class="warpper">
            <table
                border="0"
                cellspacing="1"
                cellpadding="0"
            >
                <tr class="row-item">
                    <td colspan="3" class="row-item1-td">
                        期末余额:
                        <span class="num">{{ payableInfo.balance_end|toFixedNumber }}</span>
                        ,其中砼享云内应付:
                        <span class="num">{{ payableInfo.balance_end_inner|toFixedNumber }}</span>
                        <span class="unit">（万元）</span>
                    </td>
                </tr>
                <tr class="row-item">
                    <td colspan="3" class="row-item2-td">
                        实际采购:
                        <span class="num">{{ payableInfo.procure_actual|toFixedNumber }}</span>
                        ,其中砼享云内采购:
                        <span class="num">{{ payableInfo.procure_actual_inner|toFixedNumber }}</span>
                        <span class="unit">（万元）</span>
                    </td>
                </tr>
                <tr class="row-item">
                    <td class="row-item-purple">
                        周期
                    </td>
                    <td class="row-item-purple">
                        金额
                    </td>
                    <td rowspan="2" class="row-item-sum">
                        付款比例 {{ payableInfo.pay_rate|toFixedNumber }}%
                    </td>
                </tr>
                <tr class="row-item">
                    <td class="row-item-purple">
                        1月内
                    </td>
                    <td class="row-item-gray">
                        {{ payableInfo.paycycle1|toFixedNumber }}
                    </td>
                </tr>
                <tr class="row-item">
                    <td class="row-item-purple">
                        3月内
                    </td>
                    <td class="row-item-gray">
                        {{ payableInfo.paycycle3|toFixedNumber }}
                    </td>
                    <td rowspan="2" class="row-item-sum">
                        <span>应付减少</span>
                        <span :class="{'red': payableInfo.pay_reduce<0}">{{ payableInfo.pay_reduce|toFixedNumber }}</span>
                    </td>
                </tr>
                <tr class="row-item">
                    <td class="row-item-purple">
                        6月内
                    </td>
                    <td class="row-item-gray">
                        {{ payableInfo.paycycle6|toFixedNumber }}
                    </td>
                </tr>
            </table>
            <div class="payable-constitute">
                <h4>应付构成</h4>
                <div class="piechart">
                    <div id="pieChart"></div>
                </div>
            </div>
            <table
                border="0"
                cellspacing="1"
                cellpadding="0"
                class="actual-pay"
            >
                <tr class="row-item">
                    <td colspan="5" class="row-item-purple pay-tit">
                        <span>实际付款</span>
                        <span class="unit-name">(单位：万元)</span>
                    </td>
                </tr>
                <tr class="row-item">
                    <td class="row-item-purple">
                        分类
                    </td>
                    <td class="row-item-purple">
                        本月
                    </td>
                    <td class="row-item-purple">
                        本年
                    </td>
                    <td class="row-item-purple">
                        本年计划
                    </td>
                    <td class="row-item-purple">
                        本年完成
                    </td>
                </tr>
                <template v-for="item in payableDetail">
                    <tr class="row-item" :key="item.sort_num">
                        <td class="row-item-purple" v-text="item.type_name"></td>
                        <td class="row-item-gray">
                            {{ item.pay|toFixedNumber }}
                        </td>
                        <td class="row-item-gray">
                            {{ item.pay_year|toFixedNumber }}
                        </td>
                        <td class="row-item-gray">
                            {{ item.plan_year|toFixedNumber }}
                        </td>
                        <td class="row-item-gray">
                            {{ item.plan_year_finish|toFixedNumber }}%
                        </td>
                    </tr>
                </template>
            </table>
        </div>
    </div>
</template>
<script>
import { HeaderNav } from '@/components/';
import monthSelectTitle from '@/components/header-nav/monthSelectTitle';
import utils from '@/assets/js/utils';
import { Dialog } from 'vant';
export default {
    name: 'payable',
    components: {
        HeaderNav, monthSelectTitle,
    },
    data() {
        return {
            title: '', // 标题
            showCalendar: false, // 是否展示日历选择
            orgId: '', // 当前组织ID
            year: '', // 年
            month: '', // 月
            currentDate: new Date(),
            maxDate: '',
            payableInfo: {}, // 应付信息
            payableStruct: [], // 应付构成
            payableDetail: [], // 应付明细
        };
    },
    methods: {
        // 应付构成柱状图
        drawPayableStruct() {
            const data = [];
            const xData = [];
            this.payableStruct.map(item => {
                const json = {};
                if (!item.balance_end) {
                    item.balance_end = 0;
                } else {
                    item.balance_end = parseFloat(item.balance_end.toFixed(2));
                }
                json.value = item.balance_end;
                json.name = item.type_name;
                data.push(json);
                xData.push(item.type_name);
            });
            // 基于准备好的dom，初始化echarts实例
            const myChart = this.$echarts.init(document.getElementById('pieChart'));
            const option = {
                color: ['#5588F1', '#FCA736', '#21BDCC', '#7BB956', '#EB656F'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
                    },
                    formatter: '{b}：{c}',
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top: '15%',
                    containLabel: true,
                },
                xAxis: [
                    {
                        type: 'category',
                        data: xData,
                        axisLabel: {// 解决标签过多显示不全
                            interval: 0,
                            rotate: 30,
                            color: '#999',
                        },
                        axisTick: { show: false }, // 刻度线
                        axisLine: {
                            lineStyle: {
                                color: '#999',
                            },
                        },
                    },
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '单位(万元)',
                        splitArea: {
                            show: false,
                        },
                        axisTick: { show: false }, // 刻度线
                        axisLine: {
                            lineStyle: {
                                color: '#999',
                            },
                        },
                    },

                ],
                series: [
                    {
                        name: '应付构成',
                        type: 'bar',
                        itemStyle: {
                            normal: {
                                color: function (params) {
                                    const colorList = ['#5588F1', '#FCA736', '#21BDCC', '#7BB956', '#EB656F'];
                                    return colorList[params.dataIndex];
                                },
                            },
                        },
                        label: {
                            show: true,
                            position: 'top',
                        },
                        barWidth: '40%',
                        data: data,
                    },
                ],
            };
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option, true);
        },
        // 切换运营区
        handleChangeOrg(value) {
            this.orgId = value;
            this.getPayableInfo();
            this.getPayableStruct();
            this.getPayableDetail();
        },
        // 按月下来筛选
        changeMonth() {
            this.showCalendar = true;
        },
        // 时间格式化
        formatter(type, val) {
            if (type === 'year') {
                return `${val}年`;
            } if (type === 'month') {
                return `${val}月`;
            }
            return val;
        },
        // 返回的时间格式化
        formatDate(date) {
            return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
        },
        // 时间选择完成
        confirmMonth(value) {
            const timeStr = this.formatDate(value);
            const timeArr = timeStr.split('/');
            // eslint-disable-next-line radix
            this.year = parseInt(timeArr[0]);
            // eslint-disable-next-line radix
            this.month = parseInt(timeArr[1]);
            this.showCalendar = false;
            this.title = this.year + '年' + this.month + '月份，中国联合水泥商混业务应付情况';
            this.getPayableInfo();
            this.getPayableStruct();
            this.getPayableDetail();
        },
        // 取消时间选择
        cancelMonth() {
            this.showCalendar = false;
        },
        // 获取应付信息
        getPayableInfo() {
            this.$axios
                .get('/interfaceApi/report/PayableManager/get_payable_info/' + this.year + '/' + this.month + '/' + this.orgId)
                .then(res => {
                    if (res) {
                        this.payableInfo = res;
                    }
                }).catch(error => {
                    Dialog({ message: error.ErrorCode.Message });
                });
        },
        // 获取应付构成
        getPayableStruct() {
            this.$axios
                .get('/interfaceApi/report/PayableManager/get_payable_struct/' + this.year + '/' + this.month + '/' + this.orgId)
                .then(res => {
                    if (res) {
                        this.payableStruct = res;
                        this.drawPayableStruct();
                    }
                }).catch(error => {
                    Dialog({ message: error.ErrorCode.Message });
                });
        },
        // 获取应付明细信息
        getPayableDetail() {
            this.$axios
                .get('/interfaceApi/report/PayableManager/get_payable_detail/' + this.year + '/' + this.month + '/' + this.orgId)
                .then(res => {
                    if (res) {
                        this.payableDetail = res;
                    }
                }).catch(error => {
                    Dialog({ message: error.ErrorCode.Message });
                });
        },
    },
    mounted() {
        const value = this.$store.state.orgData[0].value;
        this.orgId = value;
        const obj = utils.getPreMon();
        this.year = obj.year;
        this.month = obj.month;
        this.maxDate = new Date(obj.year, obj.month - 1, obj.lastDate);
        this.year = 2019;
        this.month = 12;
        this.title = this.year + '年' + this.month + '月份，中国联合水泥商混业务应付情况';
        this.getPayableInfo();
        this.getPayableStruct();
        this.getPayableDetail();
    },
};
</script>

<style lang="stylus" scoped>
.payable-box
    padding-top 74rpx
    height calc(100% - 74rpx)
    .warpper
        height 100%
        overflow-x hidden
        overflow-y auto
        -webkit-overflow-scrolling touch
        .header
            width 100%
            height 30rpx
            background #F0F0F0
            font-size 12rpx
            text-align center
            line-height 30rpx
            .iconrili
                font-size 14rpx
                margin-right 6rpx
        .chart-title
            padding 15rpx 3% 10rpx
            font-size 16rpx
            position relative
            .subtitle
                float right
                color #979EA7
                font-size 10rpx
                padding-top 4rpx
        .split
            width 100%
            height 15rpx
            background #F0F0F0
        table
            width 100%
            border-spacing 0px
            border-collapse collapse
            td
                border 2.5rpx solid #fff
                border-collapse collapse
                height 45rpx
                text-align center
                width 40rpx
                font-size 14rpx
            .row-item
                td
                    background #F0F0F0
                .row-item1-td
                    background rgba(250,132,54,0.1)
                    .num
                        color #FA8436
                    .unit
                        color #979EA7
                .row-item2-td
                    background rgba(33,189,204,0.1)
                    .num
                        color #21BDCC
                    .unit
                        color #979EA7
                .row-item-purple
                    background rgba(85,136,241,0.1)
                    color #5588F1
                .row-item-gray
                    background rgba(240,240,240,0.5)
                .row-item-sum
                    background rgba(33,189,204,0.1)
                    .red
                        color #EB656F
                .pay-tit
                    position relative
                    .unit-name
                        position absolute
                        right 10rpx
                        top 15rpx
                        font-size 12rpx
                        color #999
        .payable-constitute
            background rgba(250,132,54,0.1)
            h4
                height 38rpx
                line-height 38rpx
                text-align center
                color #FA8436
                font-size 16rpx
            .piechart
                height 260rpx
                padding 10rpx
                box-sizing border-box
                #pieChart
                    width 100%
                    height 100%
                    background #fff
        .actual-pay
            margin-bottom 10rpx
</style>